module.exports = __webpack_public_path__ + "static/img/hs_js_12.9b44040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/hs_js_12.png
// module id = oLL2
// module chunks = 1